import { useState, useCallback } from 'react';
import { IBasicBreadcrumb } from 'thrive-components';

const UseRecoveryRequestsBreadcrumbs = ({onBreadcrumbClick}: {onBreadcrumbClick?: () => void;}) => {
    const initialBC: IBasicBreadcrumb = { contentId: 0, title: "All" };
    const [breadcrumbs, setBreadcrumbs] = useState<IBasicBreadcrumb[]>([initialBC]);

    const resetToAll = useCallback(() => {
        setBreadcrumbs([initialBC]);
    }, []);

    const setBreadcrumb = useCallback(
        (contentId: number, title: string) => {
            const backToAllBC: IBasicBreadcrumb = {
                contentId: 0,
                title: "All",
                onClick: () => {
                    onBreadcrumbClick?.();
                    resetToAll();
                },
            };

            setBreadcrumbs([
                backToAllBC,
                { contentId, title }
            ]);
        },
        [onBreadcrumbClick, resetToAll]
    );

    return { breadcrumbs, setBreadcrumb };
};

export default UseRecoveryRequestsBreadcrumbs;